export class FileUploadModel {
  fileToUpload: File | null = null;
  id: string;
  SIMRegistrationID: string;
  uploadtype: string;
}
